import { render, staticRenderFns } from "./CustomerTypeDetail.vue?vue&type=template&id=f6347548&scoped=true&"
import script from "./CustomerTypeDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerTypeDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTypeDetail.vue?vue&type=style&index=0&id=f6347548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6347548",
  null
  
)

export default component.exports